<template>
  <div class="card">
    <div class="card-content widget" :style="style">
      <div class="columns is-mobile">
        <div class="column is-4 is-half-mobile">
          <i :class="icon"></i>
        </div>

        <div class="column is-8 is-half-mobile has-text-right">
          <p class="title is-white is-2">{{ value }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetSimple',
  props: {
    icon: {
      default: 'fa fa-card',
    },
    value: {
      default: '',
    },
    backgroundColor: {
      type: String,
      default: '#1ab394',
    },
    color: {
      type: String,
      default: '#ffffff',
    },
  },
  data() {
    return {
      style: {
        backgroundColor: this.backgroundColor,
        color: this.color,
      },
    };
  },
};
</script>

<style scoped>
.columns, .column, p, svg {
  color: inherit
}
</style>
